import { render } from "./EmployeeDashboard.vue?vue&type=template&id=417a2754&scoped=true&ts=true"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=ts"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=ts"

import "./EmployeeDashboard.vue?vue&type=style&index=0&id=417a2754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417a2754"]])

export default __exports__